<template>
  <div class="flex flex-col flex-1">
    <topbar :showBack="true" :progressMax="quiz ? quiz.questions.length : 5" :progressIndex="index" @back="onBack" color="purple" />
    <div class="h-12 hidden xl:block"></div>
    <div v-if="quiz" class="flex flex-col p-2 flex-1">
      <div class="max-w-6xl w-full mx-auto">
        <div class="text-secondary_text">{{currentQuestion.title}}</div>
        <div>{{currentQuestion.question}}</div>
      </div>

      <div class="flex-1 md:flex max-w-6xl w-full mx-auto items-start">
        <div class="md:w-1/2 md:mr-8">  
          <card :class="{'border':true, 'border-wrong': myAnswer != correctAnswer, 'border-correct': myAnswer == correctAnswer}">
            <div class="flex items-center">
              <span class="flex-1">
                {{currentQuestion.answers[myAnswer].text}}
              </span>
              <span v-if="isCorrect">
                <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45"><path d="M959.021,845.945a.683.683,0,0,0-.966,0l-22.408,22.407-8.706-8.705a.683.683,0,0,0-.966.967l9.189,9.189a.683.683,0,0,0,.966,0l22.891-22.891A.684.684,0,0,0,959.021,845.945Z" transform="translate(-919.237 -834.802)" fill="#00c6bf"/></svg>
              </span>
              <span v-else>
                <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45"><g transform="translate(446.323 -629.784) rotate(90)"><path d="M664.994,410.6a.684.684,0,0,0-.967,0l-11.666,11.666-11.894-11.894a.684.684,0,1,0-.967.967l11.894,11.894L639.5,435.126a.684.684,0,0,0,.967.967L652.361,424.2l11.666,11.666a.684.684,0,1,0,.967-.967l-11.666-11.666,11.666-11.666A.684.684,0,0,0,664.994,410.6Z" fill="#e3064a"/></g></svg>
              </span>
            </div>
          </card>
        </div>
        <card class="flex flex-col md:w-1/2 md:ml-8" :title="$t('quiz.did-you-know')" color="purple">
          {{currentQuestion.answertext}}
        </card>
      </div>
      <div class="flex md:flex-1 items-center max-w-lg w-full mx-auto">
        <button class="btn btn-quiz-1 flex-1" @click="next()">
          <template v-if="index < quiz.questions.length - 1">
            {{$t('continue')}}
          </template>
          <template v-else>
            {{$t('exit')}}
          </template>
        </button>
      </div>
    </div>

  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  data() {
    return {
      index: 0,
    }
  },
  computed: {
    ...mapState('quiz', {
      quiz: 'rawquiz',
      myAnswers: (state) => state.answers ? state.answers.answers : null,
    }),
    currentQuestion() {
      if(this.quiz) {
        return this.quiz.questions[this.index]
      }
      return null
    },
    myAnswer() {
      if(this.myAnswers) {
        return parseInt(this.myAnswers[this.index])
      }
      return null
    },
    isCorrect() {
      return this.myAnswer == this.correctAnswer
    },
    correctAnswer() {
      if(this.currentQuestion) {
        for(const [i, a] of this.currentQuestion.answers.entries()) {
          if(a.correct) return i
        }
      }
      return null
    },
  },
  methods: {
    onBack() {
      if(this.index - 1 >= 0) {
        this.index -= 1
      } else {
        this.$emit('close')
      }
    },
    next() {
      if(this.index + 1 < this.quiz.questions.length) {
        this.index += 1
      } else {
        this.$emit('close')
      }
    }
  },
}
</script>

<style>

</style>